import { get, writable } from 'svelte/store';
import { isBrowser } from './helpers';
import { logger } from '$lib/logger';

// Extends a writable store with a localStorage persistence
export const storable = (key, initialValue) => {
  let storedValue = null;
  if (isBrowser()) {
    const item = localStorage.getItem(key);
    if (item !== null) {
      try {
        storedValue = JSON.parse(item);
      } catch (error) {
        logger.warn(`Failed to parse localStorage item "${key}"`, {
          err: error instanceof Error ? error : undefined,
        });
        // Clear the corrupted value to prevent future errors
        localStorage.removeItem(key);
      }
    }
  }
  const store = writable(storedValue ?? initialValue);

  const set = (value) => {
    if (isBrowser()) {
      // Prevent storing null when initialValue is a non-null default
      const valueToStore = value ?? initialValue;
      valueToStore
        ? localStorage.setItem(key, JSON.stringify(valueToStore))
        : localStorage.removeItem(key);
    }
    // Set the value in the store
    store.set(value ?? initialValue);
  };
  const update = (fn) => set(fn(get(store)));
  const subscribe = store.subscribe;

  return {
    set,
    update,
    subscribe,
  };
};
